import '../../assets/styles/pool.scss';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { format } from 'date-fns';
import Close from '../../assets/images/cross_white.svg';

const DISMISS_STORAGE_PREFIX = 'playgroundEventDismiss';

function isDismissedToday(eventId) {
  const stored = localStorage.getItem(`${DISMISS_STORAGE_PREFIX}:${eventId}`);
  return stored === format(new Date(), 'yyyy-MM-dd');
}

function dismissForToday(eventId) {
  localStorage.setItem(`${DISMISS_STORAGE_PREFIX}:${eventId}`, format(new Date(), 'yyyy-MM-dd'));
}

function openEventLink(link, option, navigate) {
  if (!link) return;

  if (option === 'NEW') {
    window.open(link, '_blank', 'noopener,noreferrer');
    return;
  }

  if (link.startsWith('/')) {
    navigate(link);
    return;
  }

  if (/^https?:\/\//i.test(link)) {
    window.location.href = link;
    return;
  }

  navigate(`/${link.replace(/^\//, '')}`);
}

export default function PlaygroundEventBannerPopup({ apiDomain, enabled }) {
  const navigate = useNavigate();
  const [activeEvent, setActiveEvent] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!enabled || !apiDomain) {
      setIsOpen(false);
      setActiveEvent(null);
      return;
    }

    const controller = new AbortController();

    fetch(`${apiDomain}/event/list?type=POPUP&active=true`, { signal: controller.signal })
      .then((res) => res.json())
      .then((data) => {
        if (data?.result !== 'ok' || !Array.isArray(data.infos)) return;

        const nextEvent = data.infos
          .filter((event) => event.location === 'playground' && event.bannerImage && event.useYn === 'Y')
          .sort((a, b) => (a.orderNo ?? 0) - (b.orderNo ?? 0))
          .find((event) => !isDismissedToday(event.eventId));

        if (nextEvent) {
          setActiveEvent(nextEvent);
          setIsOpen(true);
        }
      })
      .catch((error) => {
        if (error.name !== 'AbortError') {
          console.error(error);
        }
      });

    return () => controller.abort();
  }, [apiDomain, enabled]);

  const closePopup = (snoozeToday) => {
    if (snoozeToday && activeEvent?.eventId) {
      dismissForToday(activeEvent.eventId);
    }
    setIsOpen(false);
  };

  if (!isOpen || !activeEvent) {
    return null;
  }

  return (
    <div className="pool-event-popup">
      <div className="pool-event-container">
        <div className="pool-event-header" onClick={() => closePopup(false)}>
          <img src={Close} width={20} height={20} alt="닫기" />
          <span>닫기</span>
        </div>
        <div className="pool-event-content">
          <button
            type="button"
            className="pool-event-image-button"
            onClick={() => {
              openEventLink(activeEvent.link, activeEvent.option, navigate);
              closePopup(false);
            }}
            style={{ border: 'none', padding: 0, background: 'transparent', width: '100%', cursor: 'pointer' }}
          >
            <img className="pool-event-image" src={activeEvent.bannerImage} alt={activeEvent.title || '이벤트 안내'} />
          </button>
        </div>
        <div className="pool-event-footer" onClick={() => closePopup(true)}>
          <span>오늘 하루 안보기</span>
        </div>
      </div>
    </div>
  );
}
